import {hitGTMEcommercePurchase} from "../../../offer/tracking/ecommerce_events/hit_gtm_ecommerce_purchase";
import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {useAppDispatch} from "../../../store/hooks";
import {ViewType} from "../../../view_type/ViewType";
import {applicationLeadDataApi} from "../../api/application_lead_data_api";
import {gtmInquiryOnApplicationSuccess} from "../../tracking/lead/gtm_inquiry_on_application_success";
import {IApplicationData} from "../../types/IApplicationData";
import {IApplicationReducerData} from "../../types/IApplicationReducerData";
import {ILeadModalLeadType} from "../../types/lead/ILeadModalLeadType";

export type RecommendedOfferApplicationsType = [IApplicationData, IRecommendedOffer];

export const useTrackRecommendedOffersApplication = () => {
    const dispatch = useAppDispatch();

    return (applications: RecommendedOfferApplicationsType[], viewType: ViewType | null, leadType: ILeadModalLeadType): void => {
        // We need to fetch property offer data in order to make GTM event after application submit success
        Promise.all(
            applications.map(([application]) =>
                dispatch(applicationLeadDataApi.endpoints.getApplicationOfferDetail.initiate({offerId: application.offer})).unwrap()
            )
        ).then((offers: unknown[]) => {
            offers.forEach((offer: unknown, index: number) => {
                // Order of response from Promise.all method is preserved so we can get value from `applications` basing on the index
                const [application, recommendedOffer] = applications[index];

                //GTM purchase event
                const data = {
                    offer: {detail: offer},
                    vendor: {detail: recommendedOffer.vendor}
                } as unknown as IApplicationReducerData;

                gtmInquiryOnApplicationSuccess(application, data, viewType, leadType, true);
                hitGTMEcommercePurchase(data, viewType, leadType, application.source_section, application);
            });
        });
    };
};
